import { h } from 'preact';
import { useContext } from 'preact/hooks';
import classNames from 'classnames';
import * as keyboardEventHelpers from 'widget_main/globals/keyboardEvents';
import { kustyIcon } from 'widget_main/globals/assets/kustyIcon';
import { SettingsContext } from 'widget_main/store';
import { useTranslations } from 'i18n/hooks';
import styles from './chatIcon.scss';

import messages from './messages';

interface ChatIconProps {
  className?: string;
  size: number;
  onClick?: () => void;
  isEmbedIcon?: boolean;
}

const ChatIcon = ({ className, size, onClick, isEmbedIcon }: ChatIconProps) => {
  const chatSettings = useContext(SettingsContext);

  const embedIconUrl = chatSettings?.embedIconUrl;
  const teamIconUrl = chatSettings?.teamIconUrl;

  const iconUrl = isEmbedIcon ? embedIconUrl : teamIconUrl;

  const translations = useTranslations(messages);

  const handleKeyPress = (e: KeyboardEvent) => {
    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      if (onClick) {
        onClick();
      }
    }
  };

  const getBackgroundSize = () => {
    if (isEmbedIcon) {
      return 'contain';
    }

    if (iconUrl) {
      return 'cover';
    }

    let bgSize = size;

    if (!iconUrl) {
      if (size >= 50) {
        bgSize = size - 20;
      } else if (size >= 40) {
        bgSize = size - 17;
      } else if (size >= 30) {
        bgSize = size - 12;
      } else {
        bgSize = Math.max(size - 10, 10);
      }
    }

    return `${bgSize}px`;
  };

  return (
    <div
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : 'img'}
      aria-label={translations.chatIconAriaLabel}
      alt={translations.chatIconAltText}
      class={classNames(
        styles.chatIcon,
        {
          [styles.pointer]: !!onClick,
        },
        className,
      )}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundSize: getBackgroundSize(),
        backgroundImage: `url(${
          iconUrl || kustyIcon(chatSettings?.embedIconColor)
        })`,
      }}
      onClick={onClick}
      onKeyPress={handleKeyPress}
    />
  );
};

ChatIcon.defaultProps = {
  size: 60,
};

export default ChatIcon;
